exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-status-overlay[data-v-0b624448]{background-color:#fff;border:1px solid #ccc;border-radius:4px;box-shadow:0 2px 6px rgba(0,0,0,.2);padding:20px}.row-with-border td[data-v-0b624448],.row-with-border th[data-v-0b624448]{border-bottom:1px solid rgba(0,0,0,.2)}.card-status-message[data-v-0b624448]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b624448","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/Programs/Card-list/CardStatus.vue
// module id = 65Xp
// module chunks = 12